import { css } from "@emotion/react";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function MetricNav({ children }) {
    return <>{children}</>;
}

function Items({ children }) {
    return (
        <div
            css={css`
                display: grid;
                grid-template-columns: repeat(${children.length}, 1fr);
                grid-gap: 1px;
                background: #ddd;
                margin: -1rem -1rem 1rem -1rem;
            `}
        >
            {children.filter( c =>
                c.props.visible || c.props.visible === undefined
            ).map(c => (
                <Item key={c.props.metricKey} childProps={c.props}>
                    {c}
                </Item>
            ))}
        </div>
    );
}

MetricNav.Items = Items;

function Item({childProps , children }) {
    const { metricKey, currentKey, setKey } = childProps;
    const onClick = (() => setKey(metricKey));
    const active = currentKey == metricKey;

    return (
        <div
            onClick={onClick}
            css={css`
                background: ${active ? "#fff" : "#eee"};
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                transition: all 0.1s;
                padding: 1rem;
                &:hover {
                    background: ${!active ? "#e6e6e6" : "#fff"};
                }
            `}
        >
            {children}
        </div>
    );
}
